<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<el-divider content-position="left">选择字段</el-divider>
				<el-form-item label="" label-width="0px" label-position="left">
					<el-select size="mini" v-model="targetfield" placeholder="选择字段" filterable multiple @change="fieldChange">
						<el-option v-for="item in fieldoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-divider content-position="left">字段赋值</el-divider>
				<div ref="logistictrace_custom_form"></div>
				
				<auth v-if="authShow" :extra="authExtra" :authtab="authTab" @submit="authSubmit" @back="authBack" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [],
			"option": {
				"form": {
					"labelWidth": "200px",
					"labelPosition":"left",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import auth from '@_system/components/auth/index.vue'
	
	export default {
		mixins: [modalMixins],
		props: {
			param: {
				default: () => {
					return {}
				}
			},
			data: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '赋值',
				modal_width:500,
				modal_height:500,
				targetfield:[],
				fieldoptions:[],
				currentItem:null,
				authShow:false,
				authTab:['staff','relation','formitem'],
				authExtra:{}
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		
		},
		methods: {
			modal_init(){	
				this.authExtra.formid = this.param.formid
				this.targetfield = []
				
				this.$api.form.get(this.param.formid,{onlyfield:true}).then((res) => {
					let createrule = []
					let fieldoptions = []
					res.forEach((item)=>{
						let field = item.table+'|'+item.field
						let obj = {
							type: item.type,
							field: field,
							title: item.title + '【'+item.tablename+'】',
							value: null,
							hidden: true,
							options: item.options,
							props: item.props,
							validate: [{
								"required": false,
								"message": "必填项"
							}]
						}
						if(this.data && this.data[field]){
							obj.hidden = false
							obj.value = this.data[field]
							this.targetfield.push(field)
						}
						if(item.field.endsWith('staffid') || item.field.endsWith('departmentid')){
							obj.type = 'button'
							obj.children = ['选择']
							obj.props.type = 'primary'
							obj.props.size = 'mini'
						}
						if(item.field.endsWith('time')){
							obj.type = '$select'
							obj.options = [{
								value:'currenttime',
								label:'当前节点执行时间',
							}]
						}	
						createrule.push(obj)
						fieldoptions.push({
							value:item.table+'|'+item.field,
							label: item.title + '【'+item.tablename+'】',
						})
					})
					formjson.rule.rule = createrule
					this.fieldoptions = fieldoptions
					
					let formData = JSON.parse(JSON.stringify(formjson))
					let rule = formData.rule.rule
					let option = formData.rule.option
					option.el = this.$refs.logistictrace_custom_form
					this.fApi = this.$formCreate(rule, option)
					this.fApi.nextTick(() => {
						this.regestevent(rule)
						this.setFormData()	
					})
					this.$emit('show')					
				})
			},
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}	
						if(item.type == 'button'){
							on.click = ()=>{
								this.currentItem = item
								this.authModal()
							}
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			fieldChange(){
				formjson.rule.rule.forEach((item)=>{
					//console.log(item,this.targetfield)
					let hidden = true
					if(this.targetfield.includes(item.field)){
						hidden = false
					}else{
						hidden = true
					}
					this.fApi.updateRule(item.field, {
						hidden: hidden
					})
					if(hidden){
						this.fApi.setValue(item.field, null)
					}
				})
			},
			authModal(){
				this.authExtra.value = this.fApi.getValue(this.currentItem.field)
				if(this.currentItem.field.endsWith('staffid')){
					this.authTab = ['staff','relation','formitem']
				}
				if(this.currentItem.field.endsWith('departmentid')){
					this.authTab = ['department','relationdepartment','formitem']
				}
				//console.log(this.authValue,'show')
				this.authShow = true
			},
			authSubmit(e){
				this.fApi.setValue(this.currentItem.field, {auth:e.data})
				console.log(e.data,'submit')
			},
			authBack(){				
				this.authShow = false
			},
			back(){
				
				this.$emit('back')
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)					
					this.$emit('submit',{data:submitData})
					this.back()
					
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					console.log(submitData)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().fullData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.costorder_detail = detail
					// 		this.createJson(data)
					// 		//console.log(data,123123)
					// 		this.$emit('success', {
					// 			data: JSON.stringify(data)
					// 		})
					// 		this.modal_cancel()
					// 		console.log(data)
					// 	} else {
					// 		for (let i in res) {
					// 			this.$message.error('缺少必填项：' + res[i][0].column.title)
					// 		}
					// 	}
					// })
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			auth
		}
	}
</script>